export default __webpack_public_path__ + "static/media/headerLogoMobileSize.108fa1e8.svg";